(function () {
  var THRESHOLD = 3;

  function getRoot(node) {
    return node && node.closest ? node.closest('#preorder-tanline') : null;
  }

  function getQty(root) {
    var qtyVal = root && root.querySelector('#tl-qty-val');
    var parsed = qtyVal ? parseInt(qtyVal.textContent, 10) : 3;
    return isNaN(parsed) ? 3 : parsed;
  }

  function updatePackTotals(root, qty) {
    if (!root) return;

    var packTitle = root.querySelector('[data-tl-pack-title]');
    var canCount = root.querySelector('[data-tl-can-count]');
    var stepperUnit = root.querySelector('[data-tl-stepper-unit]');
    var packLabel = qty === 1 ? 'Variety 8-pack' : 'Variety 8-packs';

    if (packTitle) packTitle.textContent = qty + ' ' + packLabel;
    if (canCount) canCount.textContent = qty * 8;
    if (stepperUnit) stepperUnit.textContent = qty + ' ' + packLabel.toLowerCase();

    root.querySelectorAll('[data-tl-flavor-count]').forEach(function (el) {
      el.textContent = (qty * 2) + 'x';
    });
  }

  function updateBar(root) {
    var barTrack = root && root.querySelector('#tl-bar-track');
    var barFill = root && root.querySelector('#tl-bar-fill');
    var barWrap = barTrack && barTrack.closest('[role="progressbar"]');
    var msgEl = root && root.querySelector('#tl-shipping-msg');
    if (!barFill || !msgEl) return;

    var qty = getQty(root);
    updatePackTotals(root, qty);

    var pct = Math.min(qty / THRESHOLD, 1) * 100;
    if (barWrap) barWrap.setAttribute('aria-valuenow', Math.min(qty, THRESHOLD));
    root.style.setProperty('--tl-progress', pct + '%');

    if (qty >= THRESHOLD) {
      barFill.classList.add('tl-preorder__bar-fill--unlocked');
      msgEl.textContent = 'Free shipping unlocked ✨';
      msgEl.classList.add('tl-preorder__shipping-msg--unlocked');
    } else {
      barFill.classList.remove('tl-preorder__bar-fill--unlocked');
      msgEl.textContent = 'Add ' + (THRESHOLD - qty) + ' more for free shipping';
      msgEl.classList.remove('tl-preorder__shipping-msg--unlocked');
    }
  }

  function setQty(root, qty) {
    var qtyVal = root && root.querySelector('#tl-qty-val');
    var errorEl = root && root.querySelector('#tl-error');
    if (errorEl) errorEl.textContent = '';
    if (qtyVal) qtyVal.textContent = qty;
    updatePackTotals(root, qty);
    updateBar(root);
  }

  function getVariantId(root, packSize) {
    var raw = root.getAttribute('data-variant-id-' + packSize);
    var id = raw ? raw.trim() : '';
    return /^\d+$/.test(id) ? Number(id) : null;
  }

  function buildItems(root, n) {
    var v1 = getVariantId(root, 1);
    if (!v1 || n < 1) return [];

    return [{ id: v1, quantity: n }];
  }

  function handleClick(event) {
    var control = event.target.closest('#tl-qty-dec, #tl-qty-inc, #tl-atc-btn');
    if (!control) return;

    var root = getRoot(control);
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (control.id === 'tl-qty-dec') {
      setQty(root, Math.max(getQty(root) - 1, 1));
      return;
    }

    if (control.id === 'tl-qty-inc') {
      setQty(root, getQty(root) + 1);
      return;
    }

    if (control.id === 'tl-atc-btn') {
      addToCart(root, control);
    }
  }

  function addToCart(root, atcBtn) {
    var errorEl = root.querySelector('#tl-error');
    var atcLabel = root.dataset.atcLabel || 'Add to Cart';
    var items = buildItems(root, getQty(root));

    if (errorEl) errorEl.textContent = '';

    if (!items.length) {
      if (errorEl) errorEl.textContent = 'Product variants are not configured.';
      return;
    }

    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.ok ? r.json() : r.json().then(function (e) { throw e; });
      })
      .then(function () {
        atcBtn.textContent = atcLabel;
        atcBtn.disabled = false;

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            drawer.renderContents(cart);
            drawer.open();
          });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (b) {
              b.textContent = cart.item_count;
            });
          });
          window.location.href = '/cart';
        }
      })
      .catch(function (e) {
        if (errorEl) errorEl.textContent = (e && e.description) || 'Something went wrong. Please try again.';
        atcBtn.disabled = false;
        atcBtn.textContent = atcLabel;
      });
  }

  function initRoot(root) {
    if (!root) return;
    updatePackTotals(root, getQty(root));
    updateBar(root);

    if (root.tlQtyObserver) root.tlQtyObserver.disconnect();

    var qtyNode = root.querySelector('#tl-qty-val');
    if (qtyNode && window.MutationObserver) {
      root.tlQtyObserver = new MutationObserver(function () {
        updatePackTotals(root, getQty(root));
        updateBar(root);
      });
      root.tlQtyObserver.observe(qtyNode, { childList: true, characterData: true, subtree: true });
    }
  }

  function init() {
    document.querySelectorAll('#preorder-tanline').forEach(initRoot);

    if (window.tlPreorderExternalClickHandler) {
      document.removeEventListener('click', window.tlPreorderExternalClickHandler, true);
    }

    window.tlPreorderExternalClickHandler = handleClick;
    document.addEventListener('click', window.tlPreorderExternalClickHandler, true);

    if (window.location.hash === '#preorder-tanline') {
      var el = document.getElementById('preorder-tanline');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
